<!--支付方式-->
<template>
    <div class="container">
        <div class="handleBox flex flex-c flex-b">
            <p class="navTitle">客服设置 ></p>
        </div>

        <div class="service">
            <div class="flex serviceBox">
                <div class="flex flex-c">
                    <label>客服设置：</label>
                    <el-input v-model="formData.service" @focus="num = 1"  size="small"></el-input>
                </div>
            </div>
            <div class="flex serviceBox">
                <div class="flex flex-c">
                    <label>公司设置：</label>
                    <el-input v-model="formData.company"  @focus="num2 = 2" size="small"></el-input>
                </div>
            </div>
            <el-button type="primary" size="small" style="margin:50px auto 0;display: block;width:250px" @click="submit">确定</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Home',
        data: function () {
            return {
                formData: {
                    serviceId:'',
                    service: '',
                    company:'',
                    companyId:''
                },
                num:'',
                num2:''
            }
        },
        mounted: function () {
            this.getService()
            this.getCompany()
        },
        methods: {
            getService:function(){
                this.http.post('/setting/getList',{
                    type:'service'
                }).then(res=>{
                    this.formData.service = res.list[0].name
                    this.formData.serviceId = res.list[0].id
                })
            },
            getCompany:function(){
                this.http.post('/setting/getList', {
                    type: 'company'
                }).then(res => {
                    this.formData.company = res.list[0].name
                    this.formData.companyId = res.list[0].id
                })
            },

            //提交
            submit: function () {
                if(this.num == 1){
                    this.http.post('/setting/edit', {
                        id: this.formData.serviceId,
                        name: this.formData.service
                    }).then(res => {
                        this.getService()
                    })
                }
                if(this.num2 == 2){
                    this.http.post('/setting/edit', {
                        id: this.formData.companyId,
                        name: this.formData.company
                    }).then(res => {
                        this.getCompany()
                    })
                }
                this.$message.success('保存成功')
            },
        }
    }
</script>